"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudiencePromoteProduct = void 0;
var audiencePromoteProduct_1 = require("./audiencePromoteProduct");
Object.defineProperty(exports, "AudiencePromoteProduct", { enumerable: true, get: function () { return __importDefault(audiencePromoteProduct_1).default; } });
